import React from "react";
import PropTypes from "prop-types";

import TableContainer from "./common/TableContainer";
import TalkersTable, { getRows } from "./TalkersTable";

/*
Component
*/

const Talkers = ({
  dataSelector,
  fetchData,
  idSelector,
  intervalSelector,
  refresh,
}) => (
  <TableContainer
    dataSelector={dataSelector}
    fetchData={fetchData}
    getRows={getRows}
    idSelector={idSelector}
    intervalSelector={intervalSelector}
    refresh={refresh}
    Table={TalkersTable}
  />
);

Talkers.propTypes = {
  dataSelector: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  idSelector: PropTypes.func.isRequired,
  intervalSelector: PropTypes.func.isRequired,
  refresh: PropTypes.bool,
};

Talkers.defaultProps = {
  refresh: false,
};

export default Talkers;
